import React, { useState } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import VerificationInputField from "components/VerificationInputField";
import ModalChangeEmailAddressConfirmation from "screens/ModalConfirmationRequired";
import ModalGeneralFailed from "screens/ModalGeneralFailed";
import { useMutation } from "@apollo/client";
import { UPDATE_EMAIL_BY_USER_ID } from "graphql/service";
import { Head, Container, Footer } from "./styles";

const ModalChangeEmailAddress = ({
  hidden,
  buttonStyle,
  email
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [confirmationIsOpen, setConfirmationIsOpen] = useState(false);
  const [failedIsOpen, setFailedIsOpen] = useState(false);

  const [verifyEmail, { loading }] = useMutation(UPDATE_EMAIL_BY_USER_ID, {
    onCompleted: () => {
      setIsOpen(false);
      setConfirmationIsOpen(true);
    },
    onError: () => {
      setIsOpen(false);
      setFailedIsOpen(true);
    }
  })

  const handleContinue = () => {
    setIsOpen(false);
    setConfirmationIsOpen(true);
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        buttonLabel="Change Email"
        buttonStyle={buttonStyle}
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>Confirmation Required</Head>
        <Container>
          <span className="modalText">{`A verification code has been sent to your email address ${email}. Please enter the code below to continue:`}</span> 
          <VerificationInputField

          />
        </Container>
        <Footer>
          <Button
            success
            additionalstyle={`
              width: 97px;
            `}
            onClick={handleContinue}
            data-loading={loading}
          >
            {loading ? null : "Continue"}
          </Button>
        </Footer>
        <span className="modalText">{`Haven’t received the code?`}</span>
        <span className='highLight'>Resend code</span>
      </MainModal>
      <ModalChangeEmailAddressConfirmation
        isOpen={confirmationIsOpen}
        setIsOpen={setConfirmationIsOpen}
        email={email}
        retryFunction={handleContinue}
      />
      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setIsOpen={setFailedIsOpen}
        loading={loading}
        retryFunction={handleContinue}
        type="changeEmail"
      />
    </>
  );
};

export default ModalChangeEmailAddress;
